export const WORKFLOW_ID = 'HealthCareWorkflow';
export const ANALYTICS_ID = 'healthcare_workflow';
export const BACKEND_KEY = 'HealthCareGoal';
